module.exports = __webpack_public_path__ + "static/minimal-analytics-ab8a0080aeaba1664aba6043a4634b84.jpg";